export const GridId = 'kirurgi';
export const ConfigName = 'kirurgi';
export const ModuleName = 'kirurgi';
export const TableName = 'Kirurgi';
export const DisplayName = 'Kirurgi';
